"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDigitalFingerPrint = void 0;
var facct_1 = require("./facct");
var initDigitalFingerPrint = function (environment) {
    if (environment === void 0) { environment = "prod"; }
    (0, facct_1.initFacct)(environment);
    // initCybertronics(environment);
};
exports.initDigitalFingerPrint = initDigitalFingerPrint;
//# sourceMappingURL=init-digital-finger-print.js.map